import * as React from 'react';
import { Expandable } from '@warp-ds/react';
import { Group, Interval } from '../../../types';

type PriceTableProps = {
  group: Group,
  startOpen: boolean,

};
function PriceTable({
  group, startOpen,
}: PriceTableProps) {
  function formatToNorwegianPrice(price: number) {
    return Intl.NumberFormat('nb-NO').format(price);
  }

  function adCountIsInInterval(adCount: number, interval: Interval) {
    if (adCount) {
      return adCount >= interval.lowerBoundAdCount && adCount <= interval.upperBoundAdCount;
    }
    return false;
  }

  function getIntervals() {
    return (
      group.intervals.map((interval) => {
        const bounds = interval.upperBoundAdCount === 2147483647
          ? `${interval.lowerBoundAdCount}+`
          : `${interval.lowerBoundAdCount === 0 ? 0 : interval.lowerBoundAdCount + 1} - ${interval.upperBoundAdCount + 1}`;
        const isInInterval = adCountIsInInterval(group.numberOfPublishedAds, interval);
        const adText = group.numberOfPublishedAds > 1 ? 'annonser' : 'annonse';
        const adCountText = isInInterval ? ` ${adText} lagt ut siste 12 måneder` : undefined;
        return (
          <tr key={interval.specificationGroupAdIntervalId} className="justify-between items-center">
            <td className="py-12 pl-8 whitespace-nowrap flex flex-col">
              <span className={`${isInInterval ? 'font-bold' : ''}`}>{bounds}</span>
              { isInInterval && (
                <div className="text-xs mt-4">
                  <span className="font-bold">
                    <span className="font-bold">{group.numberOfPublishedAds}</span>
                  </span>
                  <span>
                    {adCountText}
                  </span>
                </div>
              )}

            </td>
            <td className={`${isInInterval ? 'font-bold' : ''} text-right py-8 pr-8 whitespace-nowrap align-baseline`}>{`${formatToNorwegianPrice(interval.price)} kr`}</td>
          </tr>
        );
      })
    );
  }

  function getNextAdPrice() {
    const correctInterval = group.intervals.find((interval) => adCountIsInInterval(group.numberOfPublishedAds, interval))
        || group.intervals[0];
    return formatToNorwegianPrice(correctInterval.price);
  }

  return (
    <Expandable
      expanded={startOpen}
      buttonClass="w-full grow"
      title={(
        <div className="flex">
          <div className="font-bold max-w-[210] sm:max-w-[600] pr-4">
            {`${group.heading}`}
          </div>
          <div className="absolute right-48">
            <span>fra</span>
            <span className="font-bold">{` ${getNextAdPrice()} kr`}</span>
          </div>
        </div>
      )}
      box
      animated
    >
      <table className="w-full">
        <thead>
          <tr className="border-b justify-between">
            <th className="pt-24 pb-8 pl-8 text-left whitespace-nowrap">Antall annonser</th>
            <th className="pt-24 pb-8 pr-8 text-right whitespace-nowrap">Pris pr. annonse</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-dashed">
          {getIntervals()}
        </tbody>
        <caption className="text-left" style={{ captionSide: 'bottom' }}>
          <span className="mt-4 text-xs">Alle priser gjelder pr. annonse og er ekskl. moms</span>
        </caption>
      </table>
    </Expandable>
  );
}

export default PriceTable;
